import React, { useRef, useState, useEffect } from "react";
import { Modal, Form, Row, Col, Switch, message, Table } from "antd";
import { Button, Input } from "antd";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined, LockOutlined, MailOutlined, HistoryOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { GetFormattedDateTime } from "../../utils/DateTimeUtils";


import DynamicSelect from "../customHooks/DynamicSelect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AddEditUsers = ({
  visible,
  onCancel,
  modalData,
  CreateSuccessfull,
  CreateFailed,
  id,
  edit = true,
  isContact,
}) => {
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [welcomeLoading, setWelcomeLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyType, setHistoryType] = useState(""); // "Password" or "Welcome"
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [cardTimestamps, setCardTimestamps] = useState({ pwd: "N/A", access: "N/A" });
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);

  const formatCardDate = (text) => {
    if (!text) return "N/A";
    const dateObj = new Date(text);
    if (isNaN(dateObj)) return "N/A";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };


  //console.log(modalData?.code);
  const phoneInputRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
    };
    const normalizedValues = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    try {
      await Axios.post(`/customer/users/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Added");
    } catch (err) {
      //console.log(err);
      // CreateFailed("Added");
    } finally {
      setLoading(false);
    }
  };
  const onFinishEdit = async (values) => {
    const payload = {
      ...values,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
    };
    try {
      await Axios.put(`/customer/users/?id=${modalData?.id}`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Edited");
    } catch (err) {
      //console.log(err);
      // CreateFailed("Edited");
    } finally {
      setLoading(false);
    }
  };

  const handleSendForgotPassword = async () => {
    if (!modalData?.id || !userInfo?.data?.id) return;
    setPasswordLoading(true);
    try {
      await Axios.get(`/setpasswordmail/${modalData?.id}/?sent_by=${userInfo?.data?.id}`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      messageApi.success("Forgot password mail sent successfully!");
    } catch (err) {
      console.error("Failed to send forgot password mail:", err);
      messageApi.error("Failed to send forgot password mail.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleFetchHistory = async (type) => {
    if (!modalData?.id) return;
    setHistoryType(type);
    setHistoryVisible(true);
    setHistoryLoading(true);
    setCurrentPage(1); // Reset to first page when opening
    setPageSize(5); // Reset to default size
    try {
      const res = await Axios.get(`/customer/lastUpdates/?user_id=${modalData?.id}`);
      if (res?.data?.status === "success") {
        const data = res.data.data;
        if (type === "Password") {
          setHistoryData(data.reset_pwd_history || []);
        } else {
          setHistoryData(data.welcome_mail_history || []);
        }
      }
    } catch (err) {
      console.error("Failed to fetch history:", err);
      messageApi.error("Failed to fetch history.");
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleSendWelcomeMail = async () => {
    if (!modalData?.email || !userInfo?.data?.id) return;
    setWelcomeLoading(true);
    try {
      await Axios.get(`/resendverification/${modalData?.email}/?sent_by=${userInfo?.data?.id}`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      messageApi.success("Welcome mail sent successfully!");
    } catch (err) {
      console.error("Failed to send welcome mail:", err);
      messageApi.error("Failed to send welcome mail.");
    } finally {
      setWelcomeLoading(false);
    }
  };

  const fetchCardTimestamps = async () => {
    if (!modalData?.id || !edit) return;
    try {
      const res = await Axios.get(`/customer/lastUpdates/?user_id=${modalData?.id}`);
      if (res?.data?.status === "success") {
        const data = res.data.data;
        setCardTimestamps({
          pwd: formatCardDate(data.pwd_lastest_update),
          access: formatCardDate(data.last_login),
        });
      }
    } catch (err) {
      console.error("Failed to fetch card timestamps:", err);
    }
  };

  useEffect(() => {
    if (visible && edit && modalData?.id) {
      fetchCardTimestamps();
    }
  }, [visible, edit, modalData?.id]);


  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  const formRef = useRef();
  const loadForm = React.useCallback(() => {
    if (edit && formRef.current) {
      const formValues = {
        user_id: modalData?.employee_id,
        first_name: modalData?.first_name,
        last_name: modalData?.last_name,
        job_title: modalData?.job_title,
        location: modalData?.location?.id || null,
        email: modalData?.email,
        phone_number: modalData?.phone_number,
        access: modalData?.access,
        role: Array.isArray(modalData?.org_role)
          ? modalData.org_role.map((r) => r?.id)
          : modalData?.role?.id
            ? [modalData.role.id]
            : [],
        is_contact: modalData?.is_contact || isContact,
      };
      formRef.current.setFieldsValue(formValues);
    }
  }, [edit, modalData, isContact]);
  useEffect(() => {
    if (modalData && formRef.current) {
      loadForm();
    }
  }, [modalData, loadForm]);
  const [phone, setPhone] = useState("");
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  return (
    <div style={{ padding: "10px" }}>
      {contextHolder}
      <div

        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <p className="modal-heading" style={{ margin: 0 }}>
          {edit ? "Edit User" : "Add User"}
        </p>
        {/* <Button onClick={handleCancel}>
          <CloseOutlined /> Back to List
        </Button> */}
      </div>
      <Form
        onFinish={edit ? onFinishEdit : onFinish2}
        name="complex-form"
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        ref={formRef}
        layout="vertical"
        style={{
          width: "100%",
          marginTop: "3rem",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">User ID</p>}>
                  <Form.Item
                    name="user_id"
                    noStyle
                    rules={[]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter ID (Optional)"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">First Name</p>}>
                  <Form.Item
                    name="first_name"
                    noStyle
                    rules={[
                      { required: true, message: "First name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter First name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Last Name</p>}>
                  <Form.Item
                    name="last_name"
                    noStyle
                    rules={[
                      { required: true, message: "Last name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Last name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Job Title</p>}>
                  <Form.Item name="job_title" noStyle>
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Title"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Email</p>}>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "email is required" },
                      {
                        type: "email",
                        message: "Please enter a valid email address",
                        validator: (_, value) => {
                          if (value) {
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (emailRegex.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Please enter a valid email address")
                            );
                          }
                          return Promise.reject(
                            new Error("Please enter your email")
                          );
                        },
                      },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter user email"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Phone No.</p>}>
                  <Form.Item noStyle name="phone_number">
                    <PhoneInput
                      // className="my-form-input"
                      ref={phoneInputRef}
                      placeholder="Enter your Phone No."
                      country="us"
                      value={phone}
                      // style={{ width: "27rem" }}
                      onChange={handlePhoneNumberChange}
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <DynamicSelect
                  name="role"
                  label="User Role"
                  url={`customer/userroles/${id}/`}
                  initialValue={modalData?.role}
                  takeFromInitial={true}
                  multiple={true}
                />
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Access</p>}>
                  <Form.Item
                    name="access"
                  // valuePropName="checked"
                  >
                    <Switch checked={modalData?.access} />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Is Contact</p>}>
                  <Form.Item
                    name="is_contact"
                  // valuePropName="checked"
                  >
                    <Switch
                      checked={modalData?.is_contact || isContact}
                      disabled
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
        {edit && (
          <Row gutter={[12, 12]} style={{ marginTop: "1.5rem", padding: "0 1rem" }}>
            <Col xs={24} md={12}>
              <div
                className="manager-card"
                style={
                  modalData?.is_verified === false
                    ? { opacity: 0.6, pointerEvents: "none" }
                    : {}
                }
              >
                <div className="manager-card-header">
                  Password Manager{" "}
                  {modalData?.is_verified === false && "(Not Verified)"}
                </div>
                <div className="manager-card-body">
                  <div className="manager-info-row">
                    <p className="manager-timestamp">
                      Last Updated At: {cardTimestamps.pwd}
                    </p>
                    <div style={{ width: "100px", height: "22px" }}></div>{" "}
                    {/* Spacer to match Access Manager switch area */}
                  </div>
                  <div className="manager-actions">
                    <Button
                      className="manager-btn"
                      onClick={handleSendForgotPassword}
                      loading={passwordLoading}
                    >
                      <LockOutlined /> Send Forgot Password Mail
                    </Button>
                    <span
                      className="manager-link"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleFetchHistory("Password")}
                    >
                      History of password mails sent
                    </span>
                  </div>


                </div>
              </div>
            </Col>

            <Col xs={24} md={12}>
              <div className="manager-card">
                <div className="manager-card-header">Access Manager</div>
                <div className="manager-card-body">
                  <div className="manager-info-row">
                    <p className="manager-timestamp">
                      Last Access: {cardTimestamps.access}
                    </p>
                    {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100px", justifyContent: "flex-end" }}>
                      <span className="manager-timestamp">Access:</span>
                      <Switch size="small" checked={modalData?.access} />
                    </div> */}
                  </div>
                  <div className="manager-actions">
                    <Button
                      className="manager-btn"
                      onClick={handleSendWelcomeMail}
                      loading={welcomeLoading}
                    >
                      <MailOutlined /> Send Welcome Mail
                    </Button>
                    <span
                      className="manager-link"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleFetchHistory("Welcome")}
                    >
                      History of welcome mails sent
                    </span>
                  </div>


                </div>
              </div>
            </Col>
          </Row>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                background: "#f58029",
                // fontWeight: "600",
              }}
              className="save-update-btn"
            >
              {edit ? "Update" : "Save"}
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>

      <Modal
        title={
          <div style={{ fontSize: "1.6rem", fontWeight: "700", color: "#34475e" }}>
            {historyType} Mail History
          </div>
        }
        visible={historyVisible}
        onCancel={() => setHistoryVisible(false)}
        footer={null}
        width={700}
        closeIcon={<CloseOutlined style={{ fontSize: "1.5rem" }} />}
      >
        <Table
          className="history-custom-table"
          dataSource={historyData}
          loading={historyLoading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["5", "10", "15", "20"],
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            },
            onShowSizeChange: (current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
          rowKey="id"
          size="small"
          bordered
          rowClassName="history-table-row"
          columns={[
            {
              title: "Sent At",
              dataIndex: "updated_at",
              key: "updated_at",
              render: (text) => GetFormattedDateTime(text, true),
              width: "35%",
            },
            {
              title: "Sent By",
              dataIndex: "sent_by_name",
              key: "sent_by_name",
              width: "30%",
            },
            {
              title: "Email Status",
              dataIndex: "email_status",
              key: "email_status",
              width: "35%",
              render: (text) => {
                const isSuccess = ["Delivery", "Sent"].includes(text);
                const color = isSuccess ? "#52c41a" : "#ff4d4f";
                return (
                  <span style={{ color, fontWeight: "600" }}>
                    {text || "N/A"}
                  </span>
                );
              },
            },
          ]}
        />
      </Modal>
    </div>

  );
};

const styles = `
.manager-card {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f5ff;
}
.manager-card-header {
  background: #8294ad;
  color: white;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
}
.manager-card-body {
  padding: 12px 16px;
  min-height: 100px;
}
.manager-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.manager-timestamp {
  font-size: 11px;
  color: #1d39c4;
  font-weight: 500;
  margin: 0;
}
.manager-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}
.manager-btn {
  background: #34475e !important;
  color: white !important;
  border: none !important;
  font-size: 11px !important;
  height: 28px !important;
  padding: 4px 8px !important;
  white-space: nowrap;
}
.manager-btn:hover {
  background: #465a73 !important;
}
.manager-link {
  font-size: 11px;
  text-decoration: underline;
  color: #1d39c4;
  white-space: nowrap;
}
.history-table-row {
  background-color: #ededed !important;
}
.history-table-row:hover > td {
  background-color: #ececec !important;
}
.history-custom-table .ant-table-thead > tr > th {
  background-color: #d9d9d9 !important;
  color: #4a4a4a !important;
  font-weight: 700 !important;
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

export default AddEditUsers;
 